import { __rest, __assign } from './_virtual/_tslib.js';
import { map } from 'rxjs/operators';
import { callApiWithStandardResponse, HttpVerb, createSwallowErrorCodesResponseHandler, HttpStatus } from '@ucc/common';

var MessagingService = /** @class */ (function () {
    function MessagingService(apiBaseUrl, httpClient) {
        var _this = this;
        this.apiBaseUrl = apiBaseUrl;
        this.httpClient = httpClient;
        /**
         * @returns total count of unread messages across all conversations for this phone number.
         */
        this.getConversationsSummary = function (params) {
            var ownerPhoneNumber = params.ownerPhoneNumber, queryParams = __rest(params, ["ownerPhoneNumber"]);
            return callApiWithStandardResponse(_this.httpClient, HttpVerb.GET, _this.apiBaseUrl + "/conversations-summary/" + ownerPhoneNumber, null, { params: queryParams });
        };
        /**
         * @returns a paginated list of conversations in which this user's phone number has sent or received SMS messages.
         */
        this.getConversations = function (params) {
            var contactPhoneNumbers = params.contactPhoneNumbers, otherParams = __rest(params
            // TODO: Support group conversations by sending query like that /messages?contactPhoneNumber=4185551234&contactPhoneNumber=4185559876&...
            // We could probably use something like that https://github.com/axios/axios/issues/709#issuecomment-452357873, but that would mean refactor our wrapper
            , ["contactPhoneNumbers"]);
            // TODO: Support group conversations by sending query like that /messages?contactPhoneNumber=4185551234&contactPhoneNumber=4185559876&...
            // We could probably use something like that https://github.com/axios/axios/issues/709#issuecomment-452357873, but that would mean refactor our wrapper
            return callApiWithStandardResponse(_this.httpClient, HttpVerb.GET, _this.apiBaseUrl + "/conversations", null, {
                params: contactPhoneNumbers
                    ? __assign(__assign({}, otherParams), { contactPhoneNumber: contactPhoneNumbers[0] }) : params,
            });
        };
        /**
         * @returns a specific SMS conversation between provided ownerPhoneNumber and contactPhoneNumbers.
         */
        this.deleteConversation = function (params) {
            var contactPhoneNumbers = params.contactPhoneNumbers, otherParams = __rest(params, ["contactPhoneNumbers"]);
            return callApiWithStandardResponse(_this.httpClient, HttpVerb.DELETE, _this.apiBaseUrl + "/conversations", null, {
                params: contactPhoneNumbers
                    ? __assign(__assign({}, otherParams), { contactPhoneNumber: contactPhoneNumbers[0] }) : params,
            });
        };
        /**
         * Update definition to be performed on a conversation between the owner's phone number and the contact's phone number.
         * Per design lastReadMessageId can only receive values greater than the current id and it's impossible to unread conversations or go in the past at the moment.
         * @returns updated conversation
         */
        this.updateConversation = function (body) {
            return callApiWithStandardResponse(_this.httpClient, HttpVerb.POST, _this.apiBaseUrl + "/update-conversation", body);
        };
        /**
         * @returns a paginated list of SMS messages in a conversation between the user's phone number and the specified contact's phone number, sorted by most recent messages first, within a given optional time range.
         */
        this.getMessages = function (params) {
            var contactPhoneNumbers = params.contactPhoneNumbers, otherParams = __rest(params
            // TODO: Support group conversations by sending query like that /messages?contactPhoneNumber=4185551234&contactPhoneNumber=4185559876&...
            // We could probably use something like that https://github.com/axios/axios/issues/709#issuecomment-452357873, but that would mean refactor our wrapper
            , ["contactPhoneNumbers"]);
            // TODO: Support group conversations by sending query like that /messages?contactPhoneNumber=4185551234&contactPhoneNumber=4185559876&...
            // We could probably use something like that https://github.com/axios/axios/issues/709#issuecomment-452357873, but that would mean refactor our wrapper
            return callApiWithStandardResponse(_this.httpClient, HttpVerb.GET, _this.apiBaseUrl + "/messages", null, {
                params: __assign(__assign({}, otherParams), { contactPhoneNumber: contactPhoneNumbers[0] }),
            });
        };
        /**
         * @returns a new SMS message to a specific contact from a given phone number.
         */
        this.sendMessage = function (messageSendPayload) {
            return callApiWithStandardResponse(_this.httpClient, HttpVerb.POST, _this.apiBaseUrl + "/messages", messageSendPayload);
        };
        /**
         * @returns a specific SMS message. If the message is deleted, there will be no body and additional information about who deleted it and when.
         */
        this.getMessage = function (params) {
            var messageId = params.messageId, queryParams = __rest(params, ["messageId"]);
            return callApiWithStandardResponse(_this.httpClient, HttpVerb.GET, _this.apiBaseUrl + "/messages/" + messageId, null, { params: queryParams });
        };
        /**
         * @param mediaId An identifier that uniquely represent a media object
         * @returns a specific media object that is uniquely identified by the mediaId
         */
        this.getMedia = function (mediaId) {
            return callApiWithStandardResponse(_this.httpClient, HttpVerb.GET, _this.apiBaseUrl + "/media/" + mediaId, undefined, {
                responseType: 'blob',
            });
        };
        /**
         * Marks a message as deleted by removing the message body and adding information about who deleted it and when. Note: subsequent GET will return the deleted SMS message, not a 404 response.
         */
        this.deleteMessage = function (params) {
            var messageId = params.messageId, queryParams = __rest(params, ["messageId"]);
            return callApiWithStandardResponse(_this.httpClient, HttpVerb.DELETE, _this.apiBaseUrl + "/messages/" + messageId, null, { params: queryParams });
        };
        /**
         * @returns a subscription for the user defined in either the authorization token or the externalUserKey. The subscription activates notifications towards the provided notification channel ID. The request may contain one or more event types to subscribe to.
         */
        this.subscribe = function (body) {
            return _this.httpClient
                .post(_this.apiBaseUrl + "/subscriptions", body)
                .pipe(map(createSwallowErrorCodesResponseHandler([HttpStatus.CONFLICT, HttpStatus.BAD_REQUEST])));
            // There is a bug in the api where sometimes the server returns 400 instead of 409 https://getjive.atlassian.net/browse/GTCC-392
            // Just remove HttpStatus.BAD_REQUEST when bug is fixed
        };
        /**
         * @returns the subscription details of the desired user where the user is defined by either the authorization token or the externalUserKey.
         */
        this.getSubscription = function (params) {
            return callApiWithStandardResponse(_this.httpClient, HttpVerb.GET, _this.apiBaseUrl + "/subscriptions", null, { params: params });
        };
        /**
         * Delete a subscription for a desired user's phone number where the user is defined in either the authorization token or the externalUserKey.
         */
        this.deleteSubscription = function (params) {
            var subscriptionId = params.subscriptionId, queryParams = __rest(params, ["subscriptionId"]);
            return _this.httpClient
                .delete(_this.apiBaseUrl + "/subscriptions/" + subscriptionId, { params: queryParams })
                .pipe(map(createSwallowErrorCodesResponseHandler([HttpStatus.NOT_FOUND])));
        };
    }
    return MessagingService;
}());

export { MessagingService };
